
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


export default {
name: 'step5',
directives: {
TransferDom
},
components: {
Previewer
},
data () {
return {
list: [
{
msrc: 'https://mylink.oss-accelerate.aliyuncs.com/5gact/greenchannel/%E7%A4%BE%E5%8D%80%E6%AA%A2%E6%B8%AC%E4%B8%AD%E5%BF%83%402x.png',
src: 'https://mylink.oss-accelerate.aliyuncs.com/5gact/greenchannel/%E7%A4%BE%E5%8D%80%E6%AA%A2%E6%B8%AC%E4%B8%AD%E5%BF%83%402x.png',
w: 600,
h: 400
}
],
options: {
getThumbBoundsFn (index) {

let thumbnail = document.querySelectorAll('.previewer-demo-img')[index]

let pageYScroll = window.pageYOffset || document.documentElement.scrollTop


let rect = thumbnail.getBoundingClientRect()

return { x: rect.left, y: rect.top + pageYScroll, w: rect.width }
}
}
}
},
methods: {
logIndexChange (arg) {
console.log(arg)
},
show (index) {
this.$refs.previewer.show(index)
}
}
}



// WEBPACK FOOTER //
// ./src/page/greenchannel/component/step3.vue